import { Component, OnInit } from '@angular/core';
import { IFAListService } from '@ifa/ifa-list.service';
import { ToastrService } from 'ngx-toastr';
import { Something_went_wrong } from '@root/app.constant';

@Component({
  selector: 'app-create-tag-dialog',
  templateUrl: './create-tag-dialog.component.html',
  styleUrls: ['./create-tag-dialog.component.scss'],
  providers: [IFAListService],
})
export class CreateTagDialogComponent implements OnInit {
  tagName: string;

  constructor(
    private ifaListService: IFAListService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  public createNewTag() {
    const obj = {
      tagName: this.tagName,
    };
    this.ifaListService.addTag(obj).subscribe(
      (response) => {
        switch (response.status) {
          case 0:
            this.toastr.success(response.message);
            break;
          case -100:
            this.toastr.error(response.message);
            break;
          case -1:
            if (response.error.errorCode === -5000) {
              this.toastr.error(response.error.errorMessage);
            } else {
              this.toastr.error(Something_went_wrong);
            }

            break;
          default:
            this.toastr.error(response.error.errorMessage);
            break;
        }
      },
      (error) => {
        switch (error.status) {
          case -100:
            this.toastr.error(error.message);
            break;
          case -1:
            this.toastr.error(Something_went_wrong);
            break;
          default:
            this.toastr.error(error.error.errorMessage);
            break;
        }
      }
    );
  }
}
